module.exports = __webpack_public_path__ + "static/media/card-icon-4.70194713.svg";